module.exports = __webpack_public_path__ + "img/TC.867b9608.png";